import * as React from "react"

import Container from "../container/container"

import * as styles from "./video.module.scss"

import Markdown from "react-markdown"

const AboutVideo = props => {
  return (
    <div className={styles.video}>
      <Container>
        <div
          className={`d-flex align-items-start justify-content-center ${styles.video__wrap}`}
        >
          <div className={styles.video__video}>
            <iframe
              style={{ margin: "0 auto" }}
              width="100%"
              height="500"
              src="https://www.youtube.com/embed/LIaOtij4wYE"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          {/* <div className={styles.video__content}>
            <h2>{props.data.VideoSection.Heading}</h2>
            <Markdown>{props.data.VideoSection.Body}</Markdown>
          </div> */}
        </div>
      </Container>
    </div>
  )
}

export default AboutVideo
